module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('canvas')
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-be36e1c8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/VAChart.vue
// module id = 1560
// module chunks = 1